const DEFAULT_HEADER = '<!DOCTYPE html><html><body>';
const DEFAULT_FOOTER = '</body></html>';
const BODY_TAG_REGEX = /<body[^>]*>/m;
const END_BODY_TAG_REGEX = /<\/body>/;
function _getHeader(template) {
  if (!BODY_TAG_REGEX.test(template)) {
    return {
      html: DEFAULT_HEADER,
      index: 0
    };
  }
  let bodyStart = template.match(BODY_TAG_REGEX)[0];
  let bodyStartEndIndex = template.indexOf(bodyStart) + bodyStart.length;
  return {
    html: template.substring(0, bodyStartEndIndex),
    index: bodyStartEndIndex
  };
}
function _getContent(template, startIndex, endIndex) {
  return {
    html: template.substring(startIndex, endIndex)
  };
}
function _getFooter(template) {
  if (!END_BODY_TAG_REGEX.test(template)) {
    return {
      html: DEFAULT_FOOTER,
      index: template.length
    };
  }
  let bodyEnd = template.match(END_BODY_TAG_REGEX)[0];
  let bodyEndIndex = template.indexOf(bodyEnd);
  return {
    html: template.substring(bodyEndIndex),
    index: template.indexOf(bodyEnd)
  };
}
function splitHtml(template) {
  let header = _getHeader(template);
  let footer = _getFooter(template);
  let content = _getContent(template, header.index, footer.index);
  return {
    header: header.html,
    footer: footer.html,
    content: content.html
  };
}
export default splitHtml;